<template>
  <q-page padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">
        Entrada Manual de Nota Fiscal
      </p>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="col-2">
        <div class="q-ml-sm texto-titulo-input">Unidade</div>
        <lista-unidades-select
          class="input-new-design"
          v-model="unidade.nome"
          :error="erros.unidade"
          :error-message="mensagensErro.unidade"
        ></lista-unidades-select>
      </div>
      <div class="col-md-3 col-sm-3 col-xs-3">
        <div class="q-ml-sm texto-titulo-input">Numero da NF.</div>
        <q-input
          v-model="cabecalho.numeroNf"
          dense
          outlined
          class="input-new-design input"
          :error="erros.numeroNf"
          :error-message="mensagensErro.numeroNf"
        />
      </div>
      <div class="col-md-3 col-sm-3 col-xs-3">
        <div class="q-ml-sm texto-titulo-input">Série da NF.</div>
        <q-input
          v-model="cabecalho.serieNf"
          dense
          outlined
          class="input-new-design input"
          :error="erros.serieNf"
          :error-message="mensagensErro.serieNf"
        />
      </div>

      <div class="col-md-3 col-sm-3 col-xs-3">
        <div class="q-ml-sm texto-titulo-input">Data Emissão</div>
        <q-input
          dense
          outlined
          class="input-new-design input"
          placeholder="DD/MM/AAAA"
          v-model="cabecalho.dataEmissao"
          mask="##/##/####"
          :error="erros.dataEmissao"
          :error-message="mensagensErro.dataEmissao"
          :rules="[
            (val) =>
              validarDataEmissao(val) ||
              'Data inválida ou futura não permitida',
          ]"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="cabecalho.dataEmissao"
                  :options="optionsFn"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="col-2">
        <div class="q-ml-sm texto-titulo-input">Centro de Custo</div>
        <q-select
          v-model="filtros.centroCustoId"
          option-label="code"
          option-value="id"
          :options="listaCentroCustos"
          dense
          map-options
          emit-value
          @filter="filtrarCentro"
          class="input-new-design"
          use-input
          outlined
          :error="erros.centroCusto"
          :error-message="mensagensErro.centroCusto"
        />
      </div>
      <div class="col-md-3 col-sm-3 col-xs-3">
        <div class="q-ml-sm texto-titulo-input">Fornecedor</div>
        <q-select
          v-model="filtros.fornecedorId"
          option-label="business_name"
          option-value="id"
          :options="listaFornecedores"
          dense
          map-options
          emit-value
          @filter="filtrarFornecedor"
          class="input-new-design"
          use-input
          outlined
          :error="erros.fornecedor"
          :error-message="mensagensErro.fornecedor"
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <q-btn
          class="input-new-design q-mt-lg"
          icon="add"
          label="Novo Fornecedor"
          style="background-color: #304f78; border-radius: 8px; color: white"
          no-caps
          @click="rightDrawerOpen = !rightDrawerOpen"
        />
      </div>
    </div>

    <div v-if="notaFiscalId == ''" class="row col-12 q-mt-lg">
      <div>
        <q-btn
          icon="done"
          label="Salvar Cabeçalho"
          style="background-color: #21324a; border-radius: 8px; color: white"
          no-caps
          :disabled="!validarDataEmissao(cabecalho.dataEmissao)"
          @click="salvarCabecalho()"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela q-ml-md text-subtitle1 text-weight-normal"
        >
          Produtos da Nota Fiscal
        </span>
      </div>
      <q-table
        :columns="columns"
        color="primary"
        class="tabela-tamanho-fixo"
        :rows="selecionados"
        :rows-per-page-options="[0]"
        table-header-class="bg-accent text-weight-bold"
        selection="multiple"
        v-model:selected="selected"
        flat
        dense
        row-key="id"
        hide-bottom
        :grid="$q.screen.lt.sm"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-8">
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Código Fornecedor: </strong>
                    <input
                      v-model="props.row.codigo_produto"
                      type="text"
                      class="input-grid"
                  /></span>
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Numero Pedido: </strong>
                    <input
                      v-model="props.row.pedido_compra"
                      type="text"
                      class="input-grid"
                  /></span>
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Unidade NF: </strong>
                    <input
                      v-model="props.row.unidade_comercial"
                      type="text"
                      class="input-grid"
                  /></span>
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Quantidade NF: </strong>
                    <q-input
                      v-model="props.row.quantidade_comercial"
                      type="number"
                      class="input-grid"
                      min="0"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  /></span>
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Valor unitário R$</strong>
                    <input
                      v-model="props.row.valor_unitario"
                      type="text"
                      class="input-grid"
                      min="0"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  /></span>
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Total: </strong>

                    <span>
                      {{
                        formatarPreco(
                          (props.row.valor_produto = calcularTotal(
                            props.row.valor_unitario,
                            props.row.quantidade_comercial
                          ))
                        )
                      }}</span
                    ></span
                  >
                </div>
                <div class="col-4">
                  <div class="row col-12 justify-end">
                    <q-btn
                      v-if="!props.selected"
                      dense
                      round
                      icon="add"
                      color="blue-6"
                      style="margin-left: 6px"
                      flat
                      @click="
                        (props.selected = true), adicionarLinha(props.row)
                      "
                    />
                    <q-btn
                      v-else
                      dense
                      round
                      icon="delete"
                      color="red"
                      style="margin-left: 6px"
                      @click="removerLinha(props.row.id)"
                      flat
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td>
              <q-btn
                v-if="!props.selected"
                dense
                round
                icon="add"
                color="blue-6"
                style="margin-left: 6px"
                flat
                @click="(props.selected = true), adicionarLinha(props.row)"
              />
              <q-btn
                v-else
                dense
                round
                icon="delete"
                color="red"
                style="margin-left: 6px"
                @click="removerLinha(props.row.id)"
                flat
              />
            </q-td>
            <q-td>
              <q-input
                dense
                outlined
                style="width: 110px"
                v-model="props.row.codigo_produto"
              />
            </q-td>
            <q-td>
              <q-input
                dense
                outlined
                style="width: 110px"
                v-model="props.row.pedido_compra"
              />
            </q-td>
            <q-td>
              <q-input
                dense
                outlined
                style="width: 110px"
                v-model="props.row.unidade_comercial"
              />
            </q-td>
            <q-td>
              <q-input
                dense
                outlined
                type="number"
                min="0"
                style="width: 110px"
                v-model="props.row.quantidade_comercial"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              />
            </q-td>
            <q-td>
              <q-input
                dense
                outlined
                type="number"
                min="0"
                style="width: 110px"
                v-model="props.row.valor_unitario"
              />
            </q-td>
            <q-td class="text-brand-5 text-weight-bold">
              <span
                v-if="
                  props.row.valor_unitario && props.row.quantidade_comercial
                "
              >
                {{
                  formatarPreco(
                    (props.row.valor_produto = calcularTotal(
                      props.row.valor_unitario,
                      props.row.quantidade_comercial
                    ))
                  )
                }}</span
              >
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div class="q-mt-xl q-mr-sm row col-12 justify-start">
        <div>
          <q-btn
            :disabled="!validarDataEmissao(cabecalho.dataEmissao)"
            label="Gerar Entrada"
            style="background-color: #21324a; border-radius: 8px; color: white"
            icon="add"
            no-caps
            class="btn-gerar-entrada"
            @click="adicionarProdutosNota()"
          />
        </div>
      </div>
    </div>
    <ModalInformacaoesAdicionais
      :rightDrawerOpen="rightDrawerOpen"
      :nomeModal="'Novo Fornecedor'"
      @fecharModal="rightDrawerOpen = false"
    >
      <template v-slot:conteudo-modal>
        <div
          class="column col-12 text-brand-5 text-weight-bold q-gutter-sm container-inputs"
        >
          <div class="col-md-2 col-sm-6 col-xs-6">
            <div class="q-ml-sm texto-titulo-input">Nome Fantasia</div>
            <q-input
              v-model="fornecedor.nomeFantasia"
              dense
              outlined
              class="input"
            />
          </div>
          <div class="col-md-2 col-sm-5 col-xs-5">
            <div class="q-ml-sm texto-titulo-input">Razão Social</div>
            <q-input
              v-model="fornecedor.razaoSocial"
              dense
              outlined
              class="input"
            />
          </div>
          <div class="col-md-2 col-sm-6 col-xs-6">
            <div class="q-ml-sm texto-titulo-input">CNPJ</div>
            <q-input
              v-model="fornecedor.cnpj"
              mask="##.###.###/####-##"
              dense
              outlined
              class="input"
            />
          </div>
        </div>
      </template>
      <template v-slot:botao-modal>
        <div>
          <q-btn
            label="Criar Fornecedor"
            no-caps
            class="q-mt-sm btn"
            style="background-color: #304f78; border-radius: 8px; color: white"
            icon="add"
            @click="criarFornecedor()"
          />
        </div>
      </template>
    </ModalInformacaoesAdicionais>
  </q-page>
</template>

<script>
import { useStore } from "vuex";
import { onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";
import { validarDataEmissao } from "../../../../helpers/dateValidation";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import ModalInformacaoesAdicionais from "../components/ModalInformacaoesAdicionais.vue";
const columns = [
  {
    name: "adicionar",
    label: "Adicionar",
    align: "left",
  },
  {
    name: "codigoFornecedor",
    label: "Código Fornecedor",
    align: "left",
  },
  {
    name: "numeroPedido",
    label: "Num do Pedido",
    align: "left",
  },
  {
    name: "unidadeNf",
    label: "Unidade NF",
    align: "left",
  },
  {
    name: "quantidadeNf",
    label: "Quantidade NF",
    align: "left",
  },
  {
    name: "valorUnidade",
    label: "R$ Unidade",
    align: "left",
  },
  {
    name: "total",
    label: "Total",
    align: "left",
  },
];
export default {
  components: { ListaUnidadesSelect, ModalInformacaoesAdicionais },
  setup() {
    const store = useStore();
    const router = useRouter();
    const quasar = useQuasar();

    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const cabecalho = ref({
      dataEmissao: new Date().toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }),
      numeroNf: "",
      serieNf: "",
    });
    const buscaCentroCusto = ref("");
    const buscaFornecedores = ref("");
    const listaCentroCustos = ref([]);
    const listaFornecedores = ref([]);
    const tenentsSemCentro = ref({
      pg: false,
      "staging-pg": false,
    });
    let loadingInner = ref(false);
    let adicionarFornecedor = ref(false);
    let loadingInnerFornecedores = ref(false);
    const filtros = ref({ centroCustoId: "", fornecedorId: "" });
    const notaFiscalId = ref("");
    const selected = ref([]);
    const rightDrawerOpen = ref(false);
    const time = ref(null);
    const selecionados = ref([
      {
        id: 1,
        codigo_produto: "",
        pedido_compra: "",
        product_code: "",
        descricao: "",
        unidade_comercial: "",
        quantidade_comercial: "",
        valor_unitario: "",
      },
    ]);
    let id = ref(1);
    const fornecedor = ref({ nomeFantasia: "", razaoSocial: "", cnpj: "" });
    const erros = ref({
      unidade: false,
      numeroNf: false,
      serieNf: false,
      dataEmissao: false,
      centroCusto: false,
      fornecedor: false,
    });

    const mensagensErro = ref({
      unidade: "",
      numeroNf: "",
      serieNf: "",
      dataEmissao: "",
      centroCusto: "",
      fornecedor: "",
    });

    const listarCentrosDeCustos = async (val) => {
      await unidade.value.id;
      try {
        loadingInner.value = true;
        const response = await store.dispatch(
          "notaFiscal/listarCentrosCustos",
          {
            vendor_id: unidade.value.id,
            per_page: 20,
            search: val,
          }
        );
        listaCentroCustos.value = response.data.results.data;
        loadingInner.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const listarFornecedores = async (val) => {
      try {
        loadingInnerFornecedores.value = true;
        const response = await store.dispatch("notaFiscal/listarFornecedores", {
          per_page: 20,
          search: val,
        });
        listaFornecedores.value = response.data.results.data;
        loadingInnerFornecedores.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const salvarCabecalho = async () => {
      if (!validarCampos()) {
        return;
      }

      try {
        const response = await store.dispatch("notaFiscal/salvarCabecalho", {
          cost_center_id: filtros.value.centroCustoId,
          data_emissao: cabecalho.value.dataEmissao,
          format: "d/m/Y",
          informacoes_complementares: "Nota fiscal manual",
          numero: cabecalho.value.numeroNf,
          provider_id: filtros.value.fornecedorId,
          serie: cabecalho.value.serieNf,
          tipo: 1,
          vendor_id: unidade.value.id,
        });
        notaFiscalId.value = response.data.model.id;

        quasar.notify({
          message: "Cabeçalho salvo com sucesso!",
          color: "positive",
          timeout: 3000,
        });
      } catch (error) {
        if (error.response?.data?.errors) {
          Object.keys(error.response.data.errors).forEach((key) => {
            const campo = mapearCampoAPI(key);
            if (Object.prototype.hasOwnProperty.call(erros.value, campo)) {
              const mensagemErro = error.response.data.errors[key][0];
              erros.value[campo] = true;
              mensagensErro.value[campo] = mensagemErro;
              mostrarNotificacao(mensagemErro);
            }
          });
        } else {
          mostrarNotificacao("Erro ao salvar o cabeçalho. Tente novamente.");
        }
      }
    };

    const mapearCampoAPI = (campoAPI) => {
      const mapeamento = {
        cost_center_id: "centroCusto",
        data_emissao: "dataEmissao",
        numero: "numeroNf",
        provider_id: "fornecedor",
        serie: "serieNf",
        vendor_id: "unidade",
      };
      return mapeamento[campoAPI] || campoAPI;
    };

    const adicionarLinha = (row) => {
      selecionados.value.push({
        id: row.id + 1,
        codigo_produto: row.codigo_produto,
        pedido_compra: row.pedido_compra,
        product_code: "",
        descricao: "",
        unidade_comercial: row.unidade_comercial,
        quantidade_comercial: row.quantidade_comercial,
        valor_unitario: row.valor_unitario,
        valor_produto: row.valor_produto,
      });
      resetLinha();
    };

    const resetLinha = () => {
      const lastIndex = selecionados.value.length - 1;
      selecionados.value[lastIndex].codigo_produto = "";
      selecionados.value[lastIndex].pedido_compra = "";
      selecionados.value[lastIndex].unidade_comercial = "";
      selecionados.value[lastIndex].quantidade_comercial = "";
      selecionados.value[lastIndex].valor_unitario = "";
    };

    const removerLinha = (id) => {
      selecionados.value = selecionados.value.filter(
        (selecionado) => selecionado.id != id
      );
    };

    const adicionarProdutosNota = async () => {
      if (selected.value == "") {
        quasar.notify({
          message: "Adicione ao menos um produto",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("notaFiscal/adicionarProdutosNota", {
          products: selected.value,
          nf_id: notaFiscalId.value,
        });
        quasar.notify({
          message: "Entrada gerada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        router.push({
          name: "nf-editar",
          params: { notaId: notaFiscalId.value },
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao gerar entrada",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const parsearValor = (valor) => {
      if (!valor && valor !== 0) return 0;
      let str = String(valor).trim();

      const temVirgula = str.includes(",");
      const temPonto = str.includes(".");

      if (temVirgula && temPonto) {
        const posVirgula = str.lastIndexOf(",");
        const posPonto = str.lastIndexOf(".");
        if (posVirgula > posPonto) {
          // padrao BR: "1.234,56" → remove pontos, troca virgula por ponto
          str = str.replace(/\./g, "").replace(",", ".");
        } else {
          // padrao US: "1,234.56" → remove virgulas
          str = str.replace(/,/g, "");
        }
      } else if (temVirgula) {
        // só virgula = decimal: "1234,56" -> "1234.56"
        str = str.replace(",", ".");
      } else if (temPonto) {
        const partes = str.split(".");
        // ponto com 3 digitos apos = milhar: "1.234" -> "1234"
        if (partes.length === 2 && partes[1].length === 3) {
          str = str.replace(/\./g, "");
        }
        // senao mantem como decimal: "1.5", "1.56"
      }

      return parseFloat(str) || 0;
    };

    const formatarPreco = (value) => {
      if (!value && value !== 0) return "R$ 0,00";
      const num = typeof value === "number" ? value : parsearValor(value);
      if (isNaN(num)) return "R$ 0,00";

      const str = num.toString();
      const dotIndex = str.indexOf(".");
      let decimalPlaces = 2;
      if (dotIndex !== -1) {
        const decimals = str.slice(dotIndex + 1).replace(/0+$/, "");
        decimalPlaces = Math.min(Math.max(decimals.length, 2), 4);
      }

      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
      }).format(num);
    };

    const calcularTotal = (valorUnitario, quantidadeComercial) => {
      const valor = parsearValor(valorUnitario);
      const quantidade = parsearValor(quantidadeComercial);

      if (isNaN(valor) || isNaN(quantidade)) return 0;

      const total = valor * quantidade;
      return total;
    };

    const criarFornecedor = async () => {
      if (fornecedor.value.cnpj.length < 18) {
        quasar.notify({
          message: "Digite o CNPJ completo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        await store.dispatch("notaFiscal/adicionarFornecedor", {
          business_name: fornecedor.value.razaoSocial,
          cnpj: fornecedor.value.cnpj,
          fantasy_name: fornecedor.value.nomeFantasia,
        });
        fornecedor.value = {
          nomeFantasia: "",
          cnpj: "",
          razaoSocial: "",
        };
        adicionarFornecedor.value = false;
        quasar.notify({
          message: "Fornecedor criado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        rightDrawerOpen.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro ao criar fornecedor",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const validarCampos = () => {
      let valido = true;

      Object.keys(erros.value).forEach((key) => {
        erros.value[key] = false;
        mensagensErro.value[key] = "";
      });

      if (!unidade.value.id) {
        erros.value.unidade = true;
        mensagensErro.value.unidade = "Unidade é obrigatória";
        mostrarNotificacao("Unidade é obrigatória");
        valido = false;
      }

      if (!cabecalho.value.numeroNf) {
        erros.value.numeroNf = true;
        mensagensErro.value.numeroNf = "Número da NF é obrigatório";
        mostrarNotificacao("Número da NF é obrigatório");
        valido = false;
      }

      if (!cabecalho.value.serieNf) {
        erros.value.serieNf = true;
        mensagensErro.value.serieNf = "Série da NF é obrigatória";
        mostrarNotificacao("Série da NF é obrigatória");
        valido = false;
      }

      if (!cabecalho.value.dataEmissao) {
        erros.value.dataEmissao = true;
        mensagensErro.value.dataEmissao = "Data de emissão é obrigatória";
        mostrarNotificacao("Data de emissão é obrigatória");
        valido = false;
      }

      if (
        !filtros.value.centroCustoId &&
        tenentsSemCentro.value[store.state.autenticacao.cliente[0]] == undefined
      ) {
        erros.value.centroCusto = true;
        mensagensErro.value.centroCusto = "Centro de custo é obrigatório";
        mostrarNotificacao("Centro de custo é obrigatório");
        valido = false;
      }

      if (!filtros.value.fornecedorId) {
        erros.value.fornecedor = true;
        mensagensErro.value.fornecedor = "Fornecedor é obrigatório";
        mostrarNotificacao("Fornecedor é obrigatório");
        valido = false;
      }

      return valido;
    };

    const mostrarNotificacao = (mensagem) => {
      quasar.notify({
        message: `Erro ao salvar: ${mensagem}`,
        color: "negative",
        position: "bottom",
        timeout: 3000,
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    const backPage = async () => {
      router.back();
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
        listarCentrosDeCustos();
      }
    );

    watch(
      () => buscaFornecedores.value,
      () => {
        listarFornecedores();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value.nome = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    onMounted(listarCentrosDeCustos);
    onMounted(listarFornecedores);

    return {
      columns,
      unidade,
      cabecalho,
      listarCentrosDeCustos,
      buscaCentroCusto,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      loadingInner,
      listaCentroCustos,
      filtros,
      listarFornecedores,
      buscaFornecedores,
      listaFornecedores,
      loadingInnerFornecedores,
      salvarCabecalho,
      notaFiscalId,
      selected,
      selecionados,
      id,
      rightDrawerOpen,
      adicionarLinha,
      filtrarCentro(val, update) {
        clearTimeout(time.value);

        time.value = setTimeout(() => {
          listarCentrosDeCustos(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
      filtrarFornecedor(val, update) {
        clearTimeout(time.value);

        time.value = setTimeout(() => {
          listarFornecedores(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },

      resetLinha,
      removerLinha,
      adicionarProdutosNota,
      calcularTotal,
      formatarPreco,
      parsearValor,
      adicionarFornecedor,
      fornecedor,
      criarFornecedor,
      backPage,
      erros,
      mensagensErro,
      validarCampos,
      mapearCampoAPI,
      mostrarNotificacao,
      validarDataEmissao,
      optionsFn(date) {
        var hoje = new Date();

        var ontem = new Date(hoje.getTime());
        ontem.setDate(hoje.getDate());

        var dd = ontem.getDate();
        var mm = ontem.getMonth() + 1;
        var yyyy = ontem.getFullYear();

        if (dd < 10) {
          dd = "0" + dd;
        }

        if (mm < 10) {
          mm = "0" + mm;
        }

        var data_ok = yyyy + "/" + mm + "/" + dd;

        return date <= data_ok;
      },
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}
.align-center {
  align-items: center;
}

.texto-titulo-input {
  color: #21324a !important;
}
.texto-titulo-tabela {
  color: #21324a;
}
/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
.q-field--error .q-field__control {
  border-color: #c10015 !important;
}

.q-field--error .q-field__label {
  color: #c10015 !important;
}

.texto-erro {
  color: #c10015;
  font-size: 12px;
  margin-top: 4px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
    color: #21324a !important;
  }
  .text {
    display: inline;
    font-size: 8px;
    display: none;
  }
  .select {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }
  .container-centro-custo {
    margin: 50px 0px 0px 0px;
  }
  .radio-centro {
    font-size: 12px;
  }
  .btn {
    font-size: 12px;
  }
  .btn-cabecalho {
    font-size: 12px;
    margin: 0px 0px 0px 0px;
  }
  .btn-gerar-entrada {
    font-size: 12px;
    margin: 0px 0px 0px 0px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
    color: #21324a;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .input-grid {
    width: 70px;
    outline: none;
  }
}
</style>
